/**
 * Dictionary toggle count formatting — web port of
 * client-native/src/features/dictionary/dictionaryCountFormat.ts (#743).
 *
 * Counts under 10,000 render with thousands separators (e.g. "1,234"); larger
 * counts compact to "11K" / "11.2K" so big values stay readable in the
 * Learning/Known segmented control.
 */
const COMPACT_COUNT_THRESHOLD = 10000;

export const formatDictionaryToggleCount = (count: number): string => {
  if (count < COMPACT_COUNT_THRESHOLD) {
    return count.toLocaleString("en-US");
  }

  const compactCount = count / 1000;
  const maximumFractionDigits = count % 1000 === 0 ? 0 : 1;
  return `${compactCount.toLocaleString("en-US", {
    maximumFractionDigits,
  })}K`;
};
